module.exports = __webpack_public_path__ + "static/img/our-people-company-values-grid-1.59e7322.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-values-grid-1.jpg
// module id = LTSD
// module chunks = 0